import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { StoredSearch } from "types/sidebar";

export interface InitialState {
  tenantsSearch: {
    [storeName: string]: StoredSearch[];
  };
}

const initialState: InitialState = {
  tenantsSearch: {},
};

export const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    setGlobalSearch: (state, action: PayloadAction<any>) => {
      state.tenantsSearch = action.payload;
    },
  },
});

export const { setGlobalSearch } = searchSlice.actions;

export const selectGlobalSearch = (state: RootState) =>
  state.search.tenantsSearch;

export default searchSlice.reducer;
